import { CheckoutHeader } from "../CheckoutPage";
import { __ } from "../../../translations";
import { CheckoutSteps } from "./CheckoutSteps";
import { useAppDispatch, useAppSelector } from "../../../store/store";
import {
    ensureCorrectDelivery,
    isProviderDelivery,
    isProviderDeliveryGps,
    isProviderTableservice,
    languageSelector,
    selectedSectorSelector
} from "../../../service/common.slice";
import { DownStick } from "../../../common/DownStick";
import {
    cartSelector,
    CheckoutStep, getCartStatus, navigateByCartStatus, refreshCart,
} from "../../../service/checkout.slice";
import { useNavigate } from "react-router-dom";
import { OrderTotal } from "../OrderTotal";
import { OrderItems } from "../OrderItems";
import {getDeliveryName, hasUnavailableProductsInCart, useLg, useLoading} from "../../../service/utils";
import { useEffect } from "react";
import { toast } from "react-toastify";


export const CheckoutStep1 = () => {
    const _ = useLg();
    const lang = useAppSelector(languageSelector);
    const dispatch = useAppDispatch();
    const cart = useAppSelector(cartSelector)!;
    const navigate = useNavigate();
    const sector = useAppSelector(selectedSectorSelector);
    const isDelivery = isProviderDelivery(cart.delivery?.provider);
    const isGeoLocationDelivery = isProviderDeliveryGps(cart.delivery?.provider);
    const deliveryName = cart?.delivery?.provider ? getDeliveryName(cart.delivery.provider)(lang) : "";
    const [loading, wl] = useLoading();

    const hasUnavailableProducts = hasUnavailableProductsInCart(cart);

    useEffect(() => {
        dispatch(ensureCorrectDelivery());
        dispatch(refreshCart());
    }, []); // eslint-disable-line

    const next = async () => {
        if (hasUnavailableProducts) return;

        if (!cart.delivery) {
            await showNothingSelectedToast();
            return;
        }

        await wl.load(dispatch(ensureCorrectDelivery()));
        const cartStatus = await wl.load(dispatch(getCartStatus()).unwrap());
        navigateByCartStatus(navigate, cartStatus, "/checkout/step2");
    };

    const showNothingSelectedToast = async () => {
        toast.error(_('Du musst noch auswählen, ob du dein Essen abholen oder liefern lassen möchtest'), {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        });
    };

    return <>
        <CheckoutHeader
            header={__("Warenkorb")}
            back={() => { navigate("/") }}
        />
        <CheckoutSteps step={CheckoutStep.Cart} />

        <div className="checkout-contents">
            <div className="box cart">
                <>
                    <div>
                        {isGeoLocationDelivery
                            ? (
                                <>
                                    <div>
                                        <span style={{ fontWeight: 'bold' }}>{deliveryName}</span>
                                    </div>
                                </>
                            )
                            : isDelivery
                            ? (
                                <>
                                    <div>
                                        <span style={{ fontWeight: 'bold' }}>{deliveryName}</span>
                                    </div>
                                    <div>
                                        <span>{_("Sektor")} {sector?.title}{", " + _("Platz") + " " + (cart?.orderlySeatNumber||"")}</span>
                                    </div>
                                </>
                            )
                            : (
                                <>
                                    <div>
                                        <span style={{ fontWeight: 'bold' }}>
                                            {deliveryName}
                                        </span>
                                    </div>
                                    <div>
                                        <span>{_("Sektor")} {sector?.title}</span>
                                        {isProviderTableservice(cart.delivery?.provider) && cart.orderlySeatNumber && <span className="right">
                                            {_("Platz")}&nbsp;
                                            {cart.orderlySeatNumber}
                                        </span>}
                                    </div>
                                </>
                            )
                        }
                    </div>
                </>
            </div>
        </div>

        <div className="checkout-contents">
            <div className="box cart">
                {hasUnavailableProducts && <div className="product-danger-container">
                    <div className="checkout-icon checkout-icon-danger-circle-red" />
                    <div>
                        {_("Wir mussten einige Produkte aus deinem Warenkorb entfernen. Sie sind leider nicht mehr verfügbar. ")}
                    </div>
                </div>}
                <OrderItems
                    orderItems={cart.items!}
                    readOnly={false}
                />
                <OrderTotal
                    cart={cart}
                    displayTipSection={false}
                />
            </div>
        </div>
        <div className="cart-sticky-container">
            <DownStick>
                <button
                    className="btn btn-primary big-primary"
                    onClick={next}
                    disabled={hasUnavailableProducts || loading}
                >
                    {isGeoLocationDelivery
                        ? _("Weiter")
                        : isDelivery
                            ? _("Sitzplatz")
                            : _("Kontaktdaten")
                    }
                </button>
            </DownStick>
        </div>
    </>;
};
